<template>
  <div style="width: 95%">
    <div
      flex
      v-for="(item, index) in optionsList"
      :key="index"
      class="option-item"
    >
      <div style="margin-right: 10px" class="questionSeq">{{ item.title }}</div>
      <bc-view-common
        flex-box="1"
        :content="item.content"
        :border="false"
        placeholder="点击编辑选项"
        :fileInfo="item.fileInfo"
      ></bc-view-common>
    </div>
    <div
      class="answer-input"
      :class="{
        isTrue: readonly && answer.answerSituation === '1',
        isFalse: readonly && answer.answerSituation === '0',
      }"
    >
      <input
        class="input"
        v-if="!readonly"
        placeholder="请输入顺序"
        type="text"
        v-model="answerStr"
        :disabled="showOptions"
        @blur="blurInput"
      />
      <input
        class="input"
        v-if="readonly"
        :readonly="readonly"
        type="text"
        v-model="answer.answerResults"
      />
    </div>
  </div>
</template>

<script>
import XEUtils from "xe-utils";
let sortString = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
import draggable from "vuedraggable";

export default {
  name: "bc-option",
  components: { draggable },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    answer: {
      type: Object,
      default: () => {},
    },
    isAnswerResults: {
      type: [String, Object],
      default: "",
    },
    typeOk: {
      type: String,
      default: "false",
    },
    isAnswerx: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
      dialogTitle: "",
      optionsList: [],
      editIndex: null,
      editModel: "create",
      sortString: sortString.split(""),
      answerStr: "",
    };
  },
  watch: {
    options: {
      handler(val) {
        this.optionsList = XEUtils.clone(val, true);
      },
      immediate: true,
    },
    answer: {
      handler(val) {},
      immediate: true,
    },
    isAnswerResults: {
      handler(val) {
        if (!val) return;
        if (val.value) {
          this.answerStr = val.value;
        } else {
          this.answerStr = val;
        }
      },
      immediate: true,
    },
  },
  computed: {
    showOptions() {
      let isAnswer = false;
      if (this.typeOk == "true") {
        isAnswer = false;
      } else {
        isAnswer = this.isAnswerx;
      }
      return isAnswer;
    },
  },
  methods: {
    blurInput() {
      let answer = this.answerStr.replace(/[^A-Z]+/gi, "");
      this.answerStr = answer.toLocaleUpperCase();
      this.$emit("change", this.answerStr);
    },
  },
};
</script>

<style lang="scss" scoped>
.create-option {
  width: 100%;
  margin-top: 10px;
  border-style: dashed !important;
}

.option-item + .option-item {
  margin-top: 16px;
}

.option-item {
  background: #fbfbfb;
  border-radius: 6px;
  padding-left: 16px;
  cursor: pointer;
  transition: all ease 0.3s;

  .questionSeq {
    padding: 8px 0;
  }

  &.isActive {
    background: #ccc;
  }
  &:hover {
    background: #ddd;
  }
  ::v-deep .content {
    cursor: pointer;
  }
  ::v-deep .stem-content {
    &.no-border {
      padding: 8px 14px !important;
      cursor: pointer;
    }
  }
}

.answer-input {
  width: 100%;
  padding: 15px;
  background: #fbfbfb;
  border-radius: 6px;
  margin-top: 16px;
  border: none;
  &.isTrue {
    border: 1px solid #70b603;
  }

  &.isFalse {
    border: 1px solid #d9001b;
  }

  .input {
    border: none;
    outline: none;
    height: 100%;
    width: 100%;
    background: transparent;
  }
}
</style>
